import React from 'react'
import { ReactComponent as MobileAppSvg} from '../../assets/svgs/Mobile_App.svg';

const MobileAppIcon = () => (
    <div>
        <MobileAppSvg/>
    </div>
)

export default MobileAppIcon